export enum ApplicationMessageType{
    GenericError,
    Warning,
    Success,
    Info,
    Error
}